import { Button } from "components/DesignSystem/Button/Button";
import { ConditionalLink } from "components/conditionalLink";
import DashboardContainer from "components/dashboard/DashboardContainer";
import { Csv } from "components/icons/Csv";
import { UploadFileIcon } from "components/icons/uploadFile";
import { ReactNode } from "react";
import { useDropzone } from "react-dropzone";

type BroadcastCsvHeaderProps = {
  title: string;
  customPagination?: ReactNode;
  onDrop: (file: File[]) => void;
  exampleTemplateUrl: string;
};

export const BroadcastCsvHeader = ({
  title,
  onDrop,
  customPagination,
  exampleTemplateUrl,
}: BroadcastCsvHeaderProps) => {
  const { open, getRootProps, getInputProps } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop,
    accept: { "text/csv": [".csv"] },
  });

  return (
    <DashboardContainer.Header>
      <div className="t-flex t-justify-between">
        <div className="t-text-body-lg t-text-text-60 after:t-font-bold after:t-text-red after:t-content-['_*'] t-mt-2">
          {title}
        </div>
        <div className="t-flex t-flex-col t-items-end t-gap-2.5">
          <div className="t-flex t-gap-4 t-items-center t-justify-between">
            <div className="t-flex t-gap-2" {...getRootProps()}>
              <input {...getInputProps()} data-testid="file-input" />
              <Button customType="icon" onClick={() => open()}>
                <span className="t-text-text-60">
                  <UploadFileIcon color="currentColor" />
                </span>
              </Button>
              <ConditionalLink to={exampleTemplateUrl}>
                <Button
                  type="button"
                  leftIcon={<Csv className="t-text-text-60" />}
                >
                  <div className="t-flex t-gap-1.5 t-items-center t-text-text-60">
                    <span className="t-text-subtext">Download Template</span>
                  </div>
                </Button>
              </ConditionalLink>
            </div>
          </div>
          {customPagination}
        </div>
      </div>
    </DashboardContainer.Header>
  );
};
